<div>
    <div *ngFor="let carousel of carouselList; let i = index">
        @if(carousel.headline.toLowerCase().includes('retrofit')){
            <div class="carousel-container retrofit_container" @carouselAnimation *ngIf="i == currentCarousel" [class]="carousel.className">
                <div class="carousel-container__parent retrofit_parent">
                    <div class="carousel-content">
                        <div class="carousel-content__header">
                            {{carousel.headline}}
                        </div>
                        <div class="carousel-content__subheader">
                            {{carousel.title}}
                        </div>
                        <div class="carousel-content__description">
                            {{carousel.content}}
                        </div>
                    </div>
                    <div class="carousel-button" *ngIf="carousel['buttonText'] !== undefined">
                        <button class="vs-secondary-btn custom-btn" (click)="clickButton(carousel)">{{carousel.buttonText}}
                        </button>
                    </div>
                </div>
                <div class="carousel-container__image">
                    <img [src]="fetchImgUrl(carousel)" alt="mediaImg">
                </div>
            </div>
        } @else {
            <div class="carousel-container" @carouselAnimation *ngIf="i == currentCarousel" [class]="carousel.className">
                <div class="carousel-container__parent">
                    <div class="carousel-content">
                        <div class="carousel-content__header">
                            {{carousel.headline}}
                        </div>
                        <div class="carousel-content__subheader">
                            {{carousel.title}}
                        </div>
                        <div class="carousel-content__description">
                            {{carousel.content}}
                        </div>
                    </div>
                    <div class="carousel-button" *ngIf="carousel['buttonText'] !== undefined">
                        <button class="vs-secondary-btn custom-btn" (click)="clickButton(carousel)">{{carousel.buttonText}}
                        </button>
                    </div>
                </div>
                <div class="carousel-container__image">
                    <img [src]="fetchImgUrl(carousel)" alt="mediaImg">
                </div>
            </div>
        }
    </div>
    <div class="progress">
        <div class="progress__dot" *ngFor="let item of carouselList; let x =index" (click)="progressCliked(x)"
            [ngClass]="{'active': x == currentCarousel}"></div>
    </div>
</div>